import { Subscription } from '../../domain/models';
import { SubscriptionRepository } from '../../domain/repositories';
import { SubscriptionDataSource } from '../datasources/SubscriptionDataSource';
import { subscriptionEntityToModel } from '../entities';

export class SubscriptionRepositoryImpl implements SubscriptionRepository {
  constructor(private dataSource: SubscriptionDataSource) {}

  async getSubscription(userId: string): Promise<Subscription | null> {
    const entity = await this.dataSource.getSubscription(userId);
    if (!entity) return null;
    return subscriptionEntityToModel(entity);
  }

  async countActiveTournaments(userId: string): Promise<number> {
    return this.dataSource.countActiveTournaments(userId);
  }

  async countActiveLeagues(userId: string): Promise<number> {
    return this.dataSource.countActiveLeagues(userId);
  }

  async countPrivateTournaments(userId: string): Promise<number> {
    return this.dataSource.countPrivateTournaments(userId);
  }

  async countActiveTeams(userId: string): Promise<number> {
    return this.dataSource.countActiveTeams(userId);
  }
}
